import React, {Fragment } from 'react';
import { NavLink } from 'react-router-dom';
function NavBarItem(props) {
    let user = JSON.parse(localStorage.getItem('user'));
    let isValid = props.role.includes(user.role);
    return (
        <Fragment>
            {isValid? 
                <li className="nav-item">
                    <NavLink className="nav-link" to={props.to}>
                        {props.label}
                    </NavLink>
                </li>
            : <Fragment></Fragment>}
        </Fragment>
    )
}


export default NavBarItem;


// WEBPACK FOOTER //
// ./src/common/NavBarItem.jsx